import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-between full-width no-wrap text-datestamp-item" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "row justify-left no-wrap" }
const _hoisted_4 = { class: "q-py-xs" }
const _hoisted_5 = { class: "row justify-left no-wrap" }
const _hoisted_6 = { class: "q-py-xs" }
const _hoisted_7 = { class: "q-py-xs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_mosta_checkbox = _resolveComponent("mosta-checkbox")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_q_toggle, {
          modelValue: _ctx.element.Positive,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.element.Positive) = $event)),
          "checked-icon": "add",
          color: "navy",
          label: "",
          size: "xs",
          "unchecked-icon": "remove"
        }, null, 8, ["modelValue"]),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "q-py-xs" }, "c: ", -1)),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.getStartDate), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, "  " + _toDisplayString(_ctx.$t('by')) + ": ", 1),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.getEndDate), 1),
        _createVNode(_component_mosta_checkbox, {
          modelValue: _ctx.element.EndDateIsToday,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.element.EndDateIsToday) = $event)),
          label: _ctx.$t('today_calendar'),
          style: {"margin-left":"6px","margin-top":"4px"}
        }, null, 8, ["modelValue", "label"])
      ])
    ]),
    _createVNode(_component_q_btn, {
      class: "q-mx-none q-mt-none unset-items-center del-btn-datestamp",
      flat: "",
      dense: "",
      "aria-label": _ctx.$t('delete_filter'),
      icon: "close",
      size: "sm",
      tabindex: "-1",
      color: "accent",
      onClick: _ctx.deleteItem
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_tooltip, { delay: 1000 }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('remove')), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["aria-label", "onClick"])
  ]))
}